var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters-field",class:{
    'filters-field--common': _vm.commonStyle
  }},[_c('div',{staticClass:"filters-field__header",class:{
      'filters-field__header': _vm.isLoading
    }},[_c('button',{attrs:{"disabled":_vm.isLoading},on:{"click":function($event){_vm.showContent = !_vm.showContent}}},[_c('dropdown-icon',{staticClass:"filters-field__header-icon",class:{
          'filters-field__header-icon--down': _vm.showContent && !_vm.isLoading
        }}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)]),((_vm.showContent || _vm.commonStyle) && !_vm.isLoading)?_c('div',{staticClass:"filters-field__content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }